import {
    Button,
    Accordion,
    AccordionActions,
    AccordionDetails,
    AccordionSummary,
    MuiThemeProvider,
    TextField,
    Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Prompt, withRouter } from 'react-router-dom';
import cs from 'classnames';
import {
    isBlank,
    isEmptyList,
    isEmptyObject,
    isNotBlank,
    isNotEmptyList
} from 'components/Common/Utils/StringUtils';
import { validateWriteAccess } from 'components/Common/ResourceAccessValidation/ResourceAccessValidation';
import * as actions from 'components/TrustCenter/store/actions';
import { PrimarySwitch } from 'components/TrustCenter/TrustCenterMuiTheme';
import {
    PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME,
    PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME,
    PRIMARY_BUTTON_LIGHT_NEGATIVE_THEME,
    PRIMARY_BUTTON_LIGHT_THEME
} from 'components/UI/Button/ButtonMuiTheme';
import TDialog from 'components/UI/Dialog/TDialog';
import * as Constants from 'constants/Constants';
import Auxiliary from 'hoc/Auxiliary';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import css from '../ProviderDetail.module.css';
import Mobility from './Mobility/Mobility';
import OEM from './OEM/OEM';
import GroupNameSearch from './TMS/GroupSearch/GroupNameSearch';
import TMS from './TMS/TMS';
import { isOtherGroupInEditMode } from './TMS/Utils/TMSUtils';
import { event } from 'components/Common/Utils/ReactGa4Utils';
import get from 'lodash/get';
import { SHARING_AGREEMENT_STATUS } from 'constants/Constants';

const Agreement = (props) => {
    const {
        connectionTypeAgreement,
        agreements,
        searchText,
        sidebarResource,
        newAgreementGroup,
        updateNewAgreementGroup,
        selectedConnection,
        newShipperAgreement,
        saveVisibilityConnections,
        toggleCreateConnection,
        selectedProvider,
        newTruckAgreements,
        session,
        groupToOpen,
        groupName,
        agreementList,
        showAgreementCreation,
        updateNewShipper,
        editedAgreements,
        saveAgreement,
        updateScrollIntoGroup,
        existingAgreementGroup,
        isAgreementInEditMode,
        disableOtherOperation,
        discardChanges,
        resetUserInputs,
        hideLocalElement,
        closeAllPanel,
        setCloseAllPanel,
        trustCenterEvents,
        currentAccountType,
        updateIndividualVisibilityAgreement
    } = props;

    const [isWriteAccessGranted, setWriteAccessGranted] = useState(false);

    const [panelExpanded, setPanelExpanded] = useState(false);

    const [status] = useState(true);

    const [selectedGroupName, setSelectedGroupName] = useState(groupName);

    const [openConfimation, setOpenConfimation] = useState(false);

    useEffect(() => {
        setWriteAccessGranted(
            validateWriteAccess(
                sidebarResource,
                Constants.TRUSTCENTER_RESOURCE,
                Constants.TRUSTCENTER_FEATURE
            )
        );
    }, [sidebarResource]);

    useEffect(() => {
        if (showAgreementCreation && isBlank(groupName)) {
            setPanelExpanded(true);
        }
    }, [showAgreementCreation]);

    useEffect(() => {
        if (groupName === groupToOpen) {
            setPanelExpanded(true);
            updateScrollIntoGroup('');
        }
    }, [groupToOpen]);

    useEffect(() => {
        if (!showAgreementCreation) setPanelExpanded(false);
    }, [searchText]);

    useEffect(() => {
        setPanelExpanded(false);
        if (groupName === undefined) {
            setPanelExpanded(true);
        } else if (closeAllPanel && groupName === groupToOpen) {
            setPanelExpanded(true);
        }
    }, [closeAllPanel]);

    useEffect(() => {
        if (panelExpanded) setPanelExpanded(false);
    }, [agreementList]);

    const handleGroupNameChange = (groupName) => {
        if (agreements.hasOwnProperty(groupName)) {
            toggleCreateConnection(false);
            updateScrollIntoGroup(groupName);
        } else {
            let tempNewAgreementGroup = { ...newAgreementGroup };
            tempNewAgreementGroup.group_name = groupName;
            setSelectedGroupName(groupName);
            updateNewAgreementGroup(tempNewAgreementGroup);
        }
        if (isNotEmptyList(Object.keys(newShipperAgreement)) && isNotBlank(groupName)) {
            let shipperAgreementList = [];
            if (isNotEmptyList(Object.keys(newShipperAgreement))) {
                shipperAgreementList = [
                    ...newShipperAgreement[Object.keys(newShipperAgreement)[0]]
                ];
                shipperAgreementList = shipperAgreementList.filter((newAgreement) => {
                    if (groupName !== Constants.SHIPPER_GROUP_NOT_APPLICABLE) {
                        return newAgreement.shipper_code === Constants.SHIPPER_CODE_ALL_SHIPPER
                            ? false
                            : true;
                    } else {
                        return true;
                    }
                });
            }
            if (isNotEmptyList(agreements[groupName])) {
                shipperAgreementList = shipperAgreementList.filter((newAgreement) => {
                    let datasource = newAgreement.datasource;
                    let sameDatasourceShipperList = agreements[groupName]
                        .filter((input) => {
                            return input.datasource.id === datasource.id;
                        })
                        .map((userInput) => {
                            return userInput.shipper_code;
                        });
                    return !sameDatasourceShipperList.includes(newAgreement.shipper_code);
                });
                updateNewAgreementGroup(Constants.AGREEMENT_GROUP_FIELD);
            }
            let updatedGroupShipperAgreements = {};
            updatedGroupShipperAgreements[groupName] = [...shipperAgreementList];
            updateNewShipper(updatedGroupShipperAgreements);
        }
    };

    const handleStatusChange = () => (event) => {
        updateIndividualVisibilityAgreement(
            selectedConnection?.id,
            groupName,
            event.target.checked
        );
    };

    const transformEventObject = (group) => {
        if (currentAccountType !== Constants.AGREEMENT_TYPE_VISIBILITY) {
            return;
        }
        let eventArray = [];
        let editedEventTypes = [];
        let unChangedEvents = false;
        if (group === Constants.AGREEMENTS_NEW_GROUP) {
            editedEventTypes = [...newAgreementGroup.event_types];
        } else if (group === Constants.AGREEMENTS_EXISTING_GROUP) {
            if (
                existingAgreementGroup.hasOwnProperty(groupName) &&
                existingAgreementGroup[groupName].hasOwnProperty('event_types')
            ) {
                editedEventTypes = [...existingAgreementGroup[groupName].event_types];
            } else {
                editedEventTypes = [...get(agreements, `["${groupName}"][0].event_types`, [])];
                unChangedEvents = true;
            }
        }
        if (isNotEmptyList(editedEventTypes)) {
            editedEventTypes.filter((row) => {
                const eventName = unChangedEvents ? row.message_type : row;
                const filterEvent = trustCenterEvents.find((eve) => eve.message_type === eventName);
                if (filterEvent !== undefined) {
                    eventArray.push(filterEvent);
                }
                return true;
            });
        }
        return eventArray;
    };

    const createAgreements = (statusToggled) => {
        event('VisibilityAgreement', 'VisibilityAgreementUpdated', `${session.accountName}`);
        let connection = {};
        let connectionId = '';
        let operation = Constants.CREATE_AGREEMENT_OPERATION;
        if (isEmptyList(Object.keys(agreements))) {
            operation = Constants.CREATE_CONNECTION_OPERATION;
        } else if (agreements.hasOwnProperty(groupName)) {
            operation = Constants.UPDATE_AGREEMENT_OPERATION;
        }
        if (Object.keys(selectedConnection).length !== 0) {
            connection = { ...selectedConnection };
            connectionId = selectedConnection.id;
        } else {
            connection.name = selectedProvider.name;
            connection.account_id = session.accountId;
            connection.provider_id = selectedProvider.id;
            connection.type = currentAccountType;
            connection.status = true;
        }
        if (connectionTypeAgreement === Constants.AGREEMENT_SHIPPER) {
            let shipperConnection = {};

            let currentGroupName = groupName;
            if (isBlank(currentGroupName)) {
                currentGroupName = selectedGroupName;
            }
            let newAgreements =
                Object.keys(newShipperAgreement).length > 0
                    ? newShipperAgreement[currentGroupName]
                    : [];
            let tempEditedAgreements =
                Object.keys(editedAgreements).length > 0 &&
                isNotEmptyList(editedAgreements[currentGroupName])
                    ? [...editedAgreements[currentGroupName]]
                    : [];
            if (isNotBlank(newAgreementGroup['group_name'])) {
                newAgreements.forEach((agreement) => {
                    Object.keys(newAgreementGroup).forEach((agreementGroupKey) => {
                        if (agreementGroupKey === 'event_types') {
                            agreement[agreementGroupKey] = transformEventObject(
                                Constants.AGREEMENTS_NEW_GROUP
                            );
                        } else {
                            agreement[agreementGroupKey] = newAgreementGroup[agreementGroupKey];
                        }
                    });
                    agreement.agreement_type = connectionTypeAgreement;
                    if (isNotEmptyList(Object.keys(agreements)) || isNotBlank(connectionId)) {
                        agreement.connection_id = connectionId;
                    }
                });
            } else {
                let userEditedAgreements = [];
                let eventTypes = [];
                eventTypes = transformEventObject(Constants.AGREEMENTS_EXISTING_GROUP);
                if (
                    (isNotEmptyList(Object.keys(existingAgreementGroup)) &&
                        isNotEmptyList(Object.keys(existingAgreementGroup[groupName]))) ||
                    statusToggled !== undefined
                ) {
                    if (isNotEmptyList(tempEditedAgreements)) {
                        let editedIdList = tempEditedAgreements.map((agreement) => agreement.id);
                        get(agreements, `["${groupName}"]`, [])?.forEach((agreement) => {
                            let temp = {};
                            if (!editedIdList.includes(agreement.id)) {
                                temp = JSON.parse(JSON.stringify(agreement));
                            } else {
                                temp = JSON.parse(
                                    JSON.stringify(
                                        tempEditedAgreements.find(
                                            (editedAgreement) => editedAgreement.id === agreement.id
                                        )
                                    )
                                );
                            }
                            if (
                                isNotEmptyList(Object.keys(existingAgreementGroup)) &&
                                isNotEmptyList(Object.keys(existingAgreementGroup[groupName]))
                            ) {
                                temp.event_types = eventTypes;
                            }
                            if (statusToggled !== undefined) {
                                temp.status = statusToggled;
                            }
                            userEditedAgreements.push(temp);
                        });
                    } else {
                        get(agreements, `["${groupName}"]`, [])?.forEach((agreement) => {
                            let temp = {};
                            temp = JSON.parse(JSON.stringify(agreement));
                            if (
                                isNotEmptyList(Object.keys(existingAgreementGroup)) &&
                                isNotEmptyList(Object.keys(existingAgreementGroup[groupName]))
                            ) {
                                temp.event_types = eventTypes;
                            }
                            if (statusToggled !== undefined) {
                                temp.status = statusToggled;
                            }
                            userEditedAgreements.push(temp);
                        });
                    }
                } else {
                    eventTypes = get(agreements, `["${groupName}"][0].event_types`, []);
                    userEditedAgreements = userEditedAgreements.concat(tempEditedAgreements);
                }
                newAgreements.forEach((agreement) => {
                    agreement.group_name = groupName;
                    agreement.event_types = eventTypes;
                    if (statusToggled !== undefined) {
                        agreement.status = statusToggled;
                    } else {
                        agreement.status = get(agreements, `["${groupName}"][0].status`, false);
                    }
                    agreement.agreement_type = connectionTypeAgreement;
                    agreement.connection_id = connectionId;
                });
                if (isNotEmptyList(userEditedAgreements)) {
                    newAgreements = newAgreements.concat(userEditedAgreements);
                }
            }
            if (isEmptyList(Object.keys(agreements)) && isBlank(connectionId)) {
                shipperConnection.connection = connection;
                shipperConnection.agreements = newAgreements;
                saveVisibilityConnections(shipperConnection);
            } else {
                saveAgreement(connectionId, newAgreements, statusToggled, operation);
            }
        } else {
            let gpsConnection = {};
            let connection = {};
            let connectionId = '';
            if (Object.keys(selectedConnection).length !== 0) {
                connection = { ...selectedConnection };
                connectionId = selectedConnection.id;
            } else {
                connection.name = selectedProvider.name;
                connection.account_id = session.accountId;
                connection.provider_id = selectedProvider.id;
                connection.type = currentAccountType;
                connection.status = true;
            }
            let gpsGroupName = Constants.GPS_ONLY;
            let newGPSAgreements =
                Object.keys(newTruckAgreements).length > 0 ? newTruckAgreements : [];
            let tempGPSEditedAgreements =
                Object.keys(editedAgreements).length > 0 &&
                isNotEmptyList(editedAgreements[gpsGroupName])
                    ? [...editedAgreements[gpsGroupName]]
                    : [];

            if (isEmptyList(agreements[groupName])) {
                newGPSAgreements.forEach((agreement) => {
                    agreement.group_name = gpsGroupName;
                    agreement.agreement_type = Constants.AGREEMENT_TRUCK;
                    agreement.status = true;
                    if (isNotEmptyList(Object.keys(agreements)) || isNotBlank(connectionId)) {
                        agreement.connection_id = connectionId;
                    }
                });
            } else {
                let userTruckEditedAgreements = [];
                if (
                    (isNotEmptyList(Object.keys(existingAgreementGroup)) &&
                        isNotEmptyList(Object.keys(existingAgreementGroup[groupName]))) ||
                    statusToggled !== undefined
                ) {
                    if (isNotEmptyList(tempGPSEditedAgreements)) {
                        let editedIdList = tempGPSEditedAgreements.map((agreement) => agreement.id);
                        get(agreements, `["${groupName}"]`, []).forEach((agreement) => {
                            let temp = {};
                            if (!editedIdList.includes(agreement.id)) {
                                temp = JSON.parse(JSON.stringify(agreement));
                            } else {
                                JSON.parse(
                                    JSON.stringify(
                                        tempGPSEditedAgreements.find(
                                            (editedAgreement) => editedAgreement.id === agreement.id
                                        )
                                    )
                                );
                            }

                            if (statusToggled !== undefined) {
                                temp.status = statusToggled;
                            }
                            userTruckEditedAgreements.push(temp);
                        });
                        newGPSAgreements = newGPSAgreements.concat(tempGPSEditedAgreements);
                    } else {
                        get(agreements, `["${groupName}"]`, [])?.forEach((agreement) => {
                            let temp = {};
                            temp = JSON.parse(JSON.stringify(agreement));

                            if (statusToggled !== undefined) {
                                temp.status = statusToggled;
                            }
                            userTruckEditedAgreements.push(temp);
                        });
                    }
                } else {
                    userTruckEditedAgreements =
                        userTruckEditedAgreements.concat(tempGPSEditedAgreements);
                }
                newGPSAgreements.forEach((agreement) => {
                    agreement.group_name = gpsGroupName;
                    if (statusToggled !== undefined) {
                        agreement.status = statusToggled;
                    } else {
                        agreement.status = get(agreements, `["${groupName}"][0].status`, false);
                    }
                    agreement.agreement_type = Constants.AGREEMENT_TRUCK;
                    agreement.connection_id = connectionId;
                });
                if (isNotEmptyList(userTruckEditedAgreements)) {
                    newGPSAgreements = newGPSAgreements.concat(userTruckEditedAgreements);
                }
            }
            if (isEmptyList(Object.keys(agreements)) && isBlank(connectionId)) {
                gpsConnection.connection = connection;
                gpsConnection.agreements = newGPSAgreements;
                saveVisibilityConnections(gpsConnection);
            } else {
                saveAgreement(connectionId, newGPSAgreements, statusToggled, operation);
            }
        }
    };
    const isExistingShipperCodesModified = () => {
        if (Object.keys(editedAgreements).length > 0) {
            if (editedAgreements.hasOwnProperty(groupName)) {
                if (isNotEmptyList(editedAgreements[groupName])) {
                    return true;
                }
            }
        }
        return false;
    };

    const isNewShipperCodesAdded = (currentGroup) => {
        if (Object.keys(newShipperAgreement).length > 0) {
            if (newShipperAgreement.hasOwnProperty(currentGroup)) {
                if (isNotEmptyList(newShipperAgreement[currentGroup])) {
                    return true;
                } else {
                    updateNewShipper({});
                }
            }
        }
        return false;
    };

    const isEventTypesChanged = () => {
        let eventChanged = false;
        const eventTypes = get(agreements, `["${groupName}"][0].event_types`, []);
        if (Object.keys(existingAgreementGroup).length > 0) {
            if (existingAgreementGroup.hasOwnProperty(groupName)) {
                if (existingAgreementGroup[groupName].hasOwnProperty('event_types')) {
                    if (existingAgreementGroup[groupName]['event_types'].length > 0) {
                        let transformedEventsList = transformEventObject(
                            Constants.AGREEMENTS_EXISTING_GROUP
                        );
                        if (transformedEventsList?.length === eventTypes?.length) {
                            transformedEventsList.forEach((addedEvents) => {
                                const found = eventTypes?.find(
                                    (eve) => eve.name === addedEvents.name
                                );
                                if (!found) {
                                    eventChanged = true;
                                }
                            });
                        } else {
                            eventChanged = true;
                        }
                    } else if (isNotEmptyList(eventTypes)) {
                        eventChanged = true;
                    }
                }
            }
        }
        return eventChanged;
    };

    const isEventTypesInvalid = (agreementGroup) => {
        if (currentAccountType === Constants.AGREEMENT_TYPE_VISIBILITY) {
            if (agreementGroup.hasOwnProperty('event_types')) {
                return agreementGroup.event_types.length === 0;
            } else {
                return true;
            }
        } else {
            return false;
        }
    };

    const disableToggle = () => {
        if (
            !isWriteAccessGranted ||
            disableOtherOperation ||
            isNotEmptyList(Object.keys(isAgreementInEditMode))
        ) {
            return true;
        }
        if (isNotBlank(groupName)) {
            return isOtherGroupInEditMode(
                newAgreementGroup,
                existingAgreementGroup,
                editedAgreements,
                newShipperAgreement,
                groupName,
                isAgreementInEditMode,
                newTruckAgreements
            );
        }
    };

    const disableSave = () => {
        let inValid = false;
        if (
            !isWriteAccessGranted ||
            disableOtherOperation ||
            isNotEmptyList(Object.keys(isAgreementInEditMode))
        ) {
            return true;
        }
        let agreementList = [];
        if (connectionTypeAgreement === Constants.AGREEMENT_SHIPPER) {
            if (isNotBlank(groupName)) {
                if (existingAgreementGroup.hasOwnProperty(groupName)) {
                    if (existingAgreementGroup[groupName].hasOwnProperty('event_types')) {
                        if (isEventTypesInvalid(existingAgreementGroup[groupName])) {
                            return true;
                        }
                    }
                } else if (
                    currentAccountType === Constants.AGREEMENT_TYPE_VISIBILITY &&
                    isEmptyList(agreements[groupName][0]['event_types'])
                ) {
                    return true;
                }
                if (
                    !isNewShipperCodesAdded(groupName) &&
                    !isExistingShipperCodesModified() &&
                    !(
                        currentAccountType === Constants.AGREEMENT_TYPE_VISIBILITY &&
                        isEventTypesChanged()
                    )
                ) {
                    return true;
                }
                if (isNotEmptyList(newShipperAgreement[selectedGroupName])) {
                    agreementList = newShipperAgreement[selectedGroupName];
                }
            } else {
                if (newAgreementGroup.group_name.length === 0) {
                    return true;
                }
                if (isEventTypesInvalid(newAgreementGroup)) {
                    return true;
                }
                if (!isNewShipperCodesAdded(selectedGroupName)) {
                    return true;
                } else {
                    if (isNotEmptyList(newShipperAgreement[groupName])) {
                        agreementList = newShipperAgreement[groupName];
                    }
                }
            }
            agreementList.forEach((agreement) => {
                if (Object.keys(agreement).length === 0) {
                    inValid = true;
                }
                if (agreement.name.length === 0 || agreement.shipper_code.length === 0) {
                    inValid = true;
                }
            });
        } else {
            if (
                !isNotEmptyList(editedAgreements[Constants.GPS_ONLY]) &&
                newTruckAgreements.length === 0
            ) {
                return true;
            }
        }
        return inValid;
    };

    const handleExpansion = (event, expanded) => {
        setPanelExpanded(!panelExpanded);
    };

    const openConfirmationDialog = (flag) => {
        setOpenConfimation(flag);
    };

    const resetRequest = (event) => {
        if (isBlank(groupName)) {
            if (currentAccountType !== Constants.AGREEMENT_TYPE_OEM) {
                toggleCreateConnection(false);
                resetUserInputs();
            } else {
                resetUserInputs();
                toggleCreateConnection(true);
            }
        } else {
            discardChanges();
        }
        openConfirmationDialog(false);
        setCloseAllPanel(false);
    };

    const getStatus = (agreements) => {
        if (isNotEmptyList(agreements)) {
            return agreements.filter((agreement) => agreement.status).length > 0;
        }
        return false;
    };

    const getRequestStatus = (agreements) => {
        if (isNotEmptyList(agreements)) {
            return agreements[0].request_status;
        }
    };

    const isPendingRequest = (agreements) => {
        if (isNotEmptyList(agreements)) {
            return agreements[0].request_status === SHARING_AGREEMENT_STATUS.PENDING;
        }
    };

    const isRejectedRequest = (agreements) => {
        if (isNotEmptyList(agreements)) {
            return agreements[0].request_status === SHARING_AGREEMENT_STATUS.REJECTED;
        }
    };

    const getGroupName = () => {
        if (connectionTypeAgreement === Constants.AGREEMENT_TRUCK) {
            return Constants.GPS_ONLY;
        } else {
            if (isNotBlank(groupName)) {
                return groupName;
            }
        }
        return '[Group Name]';
    };

    const requestStatusRender = (agreementList) => {
        const requestStatus = getRequestStatus(agreementList);
        const statusClass =
            requestStatus === SHARING_AGREEMENT_STATUS.ACCEPTED
                ? css.statusAcceptedHeader
                : requestStatus === SHARING_AGREEMENT_STATUS.REJECTED
                ? css.statusRejectedHeader
                : css.statusPendingHeader;
        return (
            <div className={cs('col-sm-1', statusClass)} id={'request-status'}>
                {requestStatus}
            </div>
        );
    };

    const disableCancel = () => {
        if (!isWriteAccessGranted) {
            return true;
        }
        if (isNotBlank(groupName)) {
            if (
                isOtherGroupInEditMode(
                    newAgreementGroup,
                    existingAgreementGroup,
                    editedAgreements,
                    newShipperAgreement,
                    groupName,
                    isAgreementInEditMode,
                    newTruckAgreements
                )
            ) {
                return true;
            }
            if (connectionTypeAgreement === Constants.AGREEMENT_SHIPPER) {
                if (
                    !isAgreementInEditMode.hasOwnProperty(groupName) &&
                    isEmptyList(newShipperAgreement[selectedGroupName]) &&
                    isEmptyList(Object.keys(existingAgreementGroup)) &&
                    isEmptyList(editedAgreements[selectedGroupName])
                ) {
                    return true;
                } else {
                    if (showAgreementCreation) {
                        toggleCreateConnection(false);
                        updateNewAgreementGroup(Constants.AGREEMENT_GROUP_FIELD);
                    }
                }
            } else {
                if (
                    !isAgreementInEditMode.hasOwnProperty(groupName) &&
                    isEmptyList(newTruckAgreements) &&
                    isEmptyList(editedAgreements[selectedGroupName])
                ) {
                    return true;
                } else {
                    if (showAgreementCreation) {
                        toggleCreateConnection(false);
                        updateNewAgreementGroup(Constants.AGREEMENT_GROUP_FIELD);
                    }
                }
            }
        }

        return false;
    };

    const dialogAction = (
        <div>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME}>
                <Button component="span" onClick={() => openConfirmationDialog(false)}>
                    No
                </Button>
            </MuiThemeProvider>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME}>
                <Button component="span" onClick={resetRequest}>
                    Yes
                </Button>
            </MuiThemeProvider>
        </div>
    );

    return (
        <div className={cs(css.agreementPanelBase, 'full-width')}>
            <div>
                {currentAccountType !== Constants.AGREEMENT_TYPE_OEM ? (
                    <Accordion
                        classes={{
                            root: css.flatPanel
                        }}
                        className={cs(css.agreementBody)}
                        square
                        expanded={panelExpanded}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={panelExpanded ? css.agreementBottom : null}
                            name={'expansion-panel'}
                            onClick={handleExpansion}
                        >
                            <div className={cs('row full-width', css.agreementPanelHeader)}>
                                <div className="col-sm-8" id={'groupName'}>
                                    {getGroupName()}
                                </div>
                                <div className={cs('col-sm-2', css.statusHeader)} id={'status'}>
                                    {isNotEmptyList(agreementList)
                                        ? getStatus(agreementList)
                                            ? 'ACTIVE'
                                            : 'INACTIVE'
                                        : null}
                                </div>
                                {requestStatusRender(agreementList)}
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={css.blockElement}>
                            <div className="row">
                                {connectionTypeAgreement === Constants.AGREEMENT_SHIPPER ? (
                                    <Auxiliary>
                                        <div className="col-sm-6">
                                            {agreementList !== undefined &&
                                            agreementList.length !== 0 ? (
                                                <TextField
                                                    disabled
                                                    fullWidth
                                                    name="group_gps"
                                                    label="Group Name"
                                                    id="group"
                                                    margin="normal"
                                                    variant="filled"
                                                    value={groupName}
                                                />
                                            ) : (
                                                <GroupNameSearch
                                                    groupName={''}
                                                    sendSelectedGroupName={handleGroupNameChange}
                                                />
                                            )}
                                        </div>
                                        <div className="col-sm-3">
                                            <TextField
                                                disabled
                                                fullWidth
                                                name="connection_type_tms"
                                                label="Connection Type"
                                                id="connection_type"
                                                margin="normal"
                                                variant="filled"
                                                value={Constants.AGREEMENT_SHIPPER}
                                            />
                                        </div>
                                    </Auxiliary>
                                ) : (
                                    <Auxiliary>
                                        <div className="col-sm-6">
                                            <TextField
                                                fullWidth
                                                disabled
                                                name="connection_type_gps"
                                                label="Connection Type"
                                                id="connection_type"
                                                margin="normal"
                                                variant="filled"
                                                value={'GPS'}
                                            />
                                        </div>
                                    </Auxiliary>
                                )}
                                <div className="col-sm-3 align-self-center">
                                    {isBlank(groupName) ||
                                    isPendingRequest(agreementList) ? null : isRejectedRequest(
                                          agreementList
                                      ) ? (
                                        <>
                                            <PrimarySwitch
                                                id={'agreement-status-switch'}
                                                onChange={(event) => handleStatusChange()(event)}
                                                disabled={isBlank(groupName) || disableToggle()}
                                                className="Switch-light-blue"
                                            />
                                            <span
                                                className={css.connectionSwitch}
                                                id={'agreement-status'}
                                            >
                                                {Constants.RESUBMIT_REQUEST}
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            <PrimarySwitch
                                                checked={
                                                    isBlank(groupName)
                                                        ? status
                                                        : getStatus(agreementList)
                                                }
                                                id={'agreement-status-switch'}
                                                onChange={(event) => handleStatusChange()(event)}
                                                disabled={isBlank(groupName) || disableToggle()}
                                                className="Switch-light-blue"
                                            />
                                            <span
                                                className={css.connectionSwitch}
                                                id={'agreement-status'}
                                            >
                                                {isBlank(groupName) || getStatus(agreementList)
                                                    ? 'ACTIVE'
                                                    : 'INACTIVE'}
                                            </span>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div>
                                {connectionTypeAgreement === Constants.AGREEMENT_SHIPPER ? (
                                    <Auxiliary>
                                        {showAgreementCreation && isEmptyObject(agreementList) && (
                                            <Typography className={css.groupHelpText}>
                                                Can’t find your Shipper Group? Email:{' '}
                                                <a href={`mailto:TTCConnection@Trimble.com`}>
                                                    TTCConnection@Trimble.com
                                                </a>
                                            </Typography>
                                        )}

                                        <TMS
                                            hideLocalElement={hideLocalElement}
                                            groupName={
                                                isNotBlank(groupName)
                                                    ? groupName
                                                    : selectedGroupName
                                            }
                                            agreementList={agreementList}
                                        />
                                    </Auxiliary>
                                ) : (
                                    <Mobility
                                        hideLocalElement={hideLocalElement}
                                        groupName={Constants.GPS_ONLY}
                                        agreementList={agreementList}
                                    />
                                )}
                            </div>
                        </AccordionDetails>
                        {!hideLocalElement && (
                            <AccordionActions>
                                <MuiThemeProvider theme={PRIMARY_BUTTON_LIGHT_NEGATIVE_THEME}>
                                    <Button
                                        id={'cancel'}
                                        size="small"
                                        disabled={disableCancel()}
                                        onClick={() => openConfirmationDialog(true)}
                                    >
                                        Cancel
                                    </Button>
                                </MuiThemeProvider>
                                <MuiThemeProvider theme={PRIMARY_BUTTON_LIGHT_THEME}>
                                    <Button
                                        id={'save'}
                                        size="small"
                                        color="primary"
                                        disabled={disableSave()}
                                        onClick={() => createAgreements()}
                                    >
                                        Save
                                    </Button>
                                </MuiThemeProvider>
                            </AccordionActions>
                        )}
                    </Accordion>
                ) : (
                    <div className={cs(css.oemAgreementPanelBase)}>
                        <OEM
                            hideLocalElement={hideLocalElement}
                            groupName={Constants.GPS_ONLY}
                            agreementList={agreementList}
                        />
                        <br />
                        <div className="text-right">
                            <MuiThemeProvider theme={PRIMARY_BUTTON_LIGHT_NEGATIVE_THEME}>
                                <Button
                                    id={'cancel'}
                                    size="small"
                                    disabled={disableCancel()}
                                    onClick={() => openConfirmationDialog(true)}
                                >
                                    Cancel
                                </Button>
                            </MuiThemeProvider>
                            <MuiThemeProvider theme={PRIMARY_BUTTON_LIGHT_THEME}>
                                <Button
                                    id={'save'}
                                    size="small"
                                    color="primary"
                                    disabled={disableSave()}
                                    onClick={() => createAgreements()}
                                >
                                    Save
                                </Button>
                            </MuiThemeProvider>
                        </div>
                    </div>
                )}
            </div>
            <TDialog
                id={'cancel_request'}
                open={openConfimation}
                handleClose={() => openConfirmationDialog(false)}
                dialogContentText={'Are you sure you want to cancel the changes?'}
                dialogTitle={'Alert'}
                dialogActions={dialogAction}
            />
            <Prompt
                when={!disableCancel()}
                message="Are you sure you want to navigate to away from this page without saving your changes?"
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        agreements:
            state.agreement.searchText === ''
                ? state.agreement.agreements
                : state.agreement.filteredAgreements,
        searchText: state.agreement.searchText,
        currentAccountType: state.connection.currentAccountType,
        disableOtherOperation: state.agreement.disableOtherOperation,
        newAgreementGroup: state.agreement.newAgreementGroup,
        selectedConnection: state.agreement.selectedConnection,
        newShipperAgreement: state.agreement.newShipperAgreement,
        selectedProvider: state.agreement.selectedProvider,
        newTruckAgreements: state.agreement.newTruckAgreements,
        showAgreementCreation: state.agreement.showAgreementCreation,
        editedAgreements: state.agreement.editedAgreements,
        groupToOpen: state.agreement.groupToOpen,
        existingAgreementGroup: state.agreement.existingAgreementGroup,
        isAgreementInEditMode: state.agreement.isAgreementInEditMode,
        sidebarResource: state.header.sidebarResource,
        session: state.session.sessionValue,
        closeAllPanel: state.agreement.closeAllPanel,
        trustCenterEvents: state.agreement.trustCenterEvents,
        carrierConfigObj: state.carrierConfig.carrierConfigObj
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateNewAgreementGroup: (agreementGroupData) =>
            dispatch(actions.updateNewAgreementGroup(agreementGroupData)),
        getAgreementsByGroupName: (id, groupName) =>
            dispatch(actions.getAgreementsByGroupName(id, groupName)),
        saveVisibilityConnections: (connection) =>
            dispatch(actions.saveVisibilityConnections(connection, false)),
        toggleCreateConnection: (showCreateConnection) =>
            dispatch(actions.toggleCreateConnection(showCreateConnection)),
        updateNewShipper: (list) => dispatch(actions.updateNewShipper(list)),
        saveAgreement: (connectionId, list, statusToggled, operation) =>
            dispatch(actions.saveAgreement(connectionId, list, statusToggled, operation)),
        updateAgreement: (connectionId, providerId, groupName, list, statusToggled) =>
            dispatch(
                actions.updateAgreement(connectionId, providerId, groupName, list, statusToggled)
            ),
        updateExistingAgreementGroup: (group) =>
            dispatch(actions.updateExistingAgreementGroup(group)),
        updateEditedAgreements: (group) => dispatch(actions.updateEditedAgreements(group)),
        updateScrollIntoGroup: (groupName) => dispatch(actions.updateScrollIntoGroup(groupName)),
        discardChanges: () => dispatch(actions.discardChanges(true)),
        resetUserInputs: () => dispatch(actions.resetUserInputs(true)),
        setCloseAllPanel: (flag) => dispatch(actions.setCloseAllPanel(flag)),
        updateIndividualVisibilityAgreement: (connectionId, groupNmae, status) =>
            dispatch(actions.updateIndividualVisibilityAgreement(connectionId, groupNmae, status))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Agreement));
